var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStzledcomponents(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 390.3 389.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "stzledcomponents") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M36.78,35.79H353.16c1.44,3.76,1.81,311.43.48,317.23-3.59,1.11-310.24,1.47-316.62.38C35.68,349.9,35.31,42.23,36.78,35.79Zm4,4.51V349.11H349.58V40.3Z",
    style: {
      fill: "#173c57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.44,186.13V154.58c1.47-1.29,3.32-2.94,5.19-4.55q12.51-10.68,25-21.36c5.44-4.63,10.84-9.33,17.46-11.78,4.91,1.79,5.72,3.08,4.33,7.42-.71,2.2-2,4.21-2.83,6.36-.61,1.52-1,3.15-1.43,4.73l.9.42c3.64-2.84,7.22-5.76,10.95-8.48a58,58,0,0,1,6.42-3.81,4.68,4.68,0,0,1,6,.7c1.58,5.29,1.06,7.23-3.86,14.28v7.58l5.14-2.85c6.67-10.68,8.28-22.8,11-34.58.33-1.43.5-2.9.71-4.22C221.8,98.78,221.44,97,226,87.05h17.89v18.66l-5.67,1.73a22.09,22.09,0,0,0-1.5,3.33c-2.46,9-4.84,17.94-7.27,26.91a23.18,23.18,0,0,1-1.19,3.79c-2.27,4.77-4.76,9.44-6.9,14.27a16.72,16.72,0,0,0-1.1,5.78c-.19,4-1.19,7.58-3.87,10.56-3.87,4.3-7.75,8.61-11.84,12.71a6.86,6.86,0,0,1-4.39,1.88c-17.81.11-35.63.05-53.45,0A13.4,13.4,0,0,1,144.44,186.13Z",
    style: {
      fill: "#173c57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.7,169.35l-4.65,4.9-37.64-23.5V142l38.1-23.62c1.37,2,2.43,3.57,3.88,5.7l-35.27,22c5.73,4.89,11.94,8,17.64,11.76S110.2,165.21,116.7,169.35Z",
    style: {
      fill: "#173c57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260,122.79l3.84-5.4L302,141.06v8.65l-37.54,23.58L260,168l35.59-22.56Z",
    style: {
      fill: "#173c57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252,296l3,1c1.25,3.4-2.12,3.29-3.49,5v9.12c5.12,1.11,10,.41,14.91.49.13-.49.27-1,.4-1.46-1.47-.81-2.91-1.71-4.43-2.42-4-1.86-5.78-4.31-5.05-7,.79-2.95,4.74-5.42,8.4-4.9,1.89.27,3.7,1.19,5.92,1.94l-1.34,3.17-6.58-.41c-.15.52-.29,1-.43,1.56,1.31.71,2.58,1.53,3.94,2.1,4.17,1.75,5.42,3.42,5,6.92-.36,3-2.24,5-6.21,5.39a21.26,21.26,0,0,1-7.73-1.19,3.55,3.55,0,0,0-1,.07c-8.39,2.94-11.36.82-11.42-8.16,0-1.66,0-3.32,0-4.76l-3-3.58c1.4-2.22,2.66-4.22,4.19-6.67l3-.4C250.84,293.24,251.41,294.56,252,296Z",
    style: {
      fill: "#173c57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.5,299.84c-4.73,1.57-4.14,4.47-4.2,7s0,5.27,0,8.4l-4.48.45c-2-5.24.48-10.65-2.2-16-6.32,4.25-1.4,11-4.52,15.81h-4.47V296.62l5.72.6c4.57-2.17,4.57-2.17,9.36.74.61-.34,1.3-.78,2-1.12,4.89-2.26,8.26-.4,8.53,5,.22,4.42,0,8.86,0,13.62l-4.85.22C131.14,310.33,130.84,305.37,130.5,299.84Z",
    style: {
      fill: "#173c57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.23,297.12c3.1-.43,6.17-1.26,9.21-1.14a8.8,8.8,0,0,1,5.62,2.46c3.8,4.1,2.81,13.51-1.81,16.63-2,1.33-4.79,1.41-7.72,2.19-.22,1.47-.53,3.55-.91,6l-3.93.42C139.61,321.71,139.58,301.35,141.23,297.12Zm5.27,13.94c3,1.55,4.58.7,5.38-1.81,1.25-3.93,0-7.5-3.22-9.09C144.68,303.08,146.54,307.13,146.5,311.06Z",
    style: {
      fill: "#173c57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.75,260.41c.17-2.29.34-4.57.55-7.37l4.56-.2v26.47l-10.19,1.17c-5.72-1.54-8.28-6.14-6.78-13.13C153.24,261,156.51,259.07,163.75,260.41Zm0,14.13v-8.61l-3.4-1.73c-3.78,2.36-3.29,5.6-2.76,8.63.22,1.25,1.44,2.31,2.29,3.6Z",
    style: {
      fill: "#173c57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.64,296.51l5.87.87a18.59,18.59,0,0,1,2.4-1.11c3.75-1.26,6.61.17,7.61,4.05,1.26,4.88.6,9.82.43,15.13l-4.64.32c-2.88-5.06.66-10.87-2.85-16-6.05,4.13-1.5,10.58-4.28,15.71l-4.54.23Z",
    style: {
      fill: "#173c57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.56,296.41l5.86,1a17.35,17.35,0,0,1,2.14-1c4-1.46,6.82-.05,8,4,.93,3.1.77,11-.38,15.06h-4.63c-.32-5.09-.63-10.06-1-15.43-4.74.92-4.38,3.91-4.41,6.63s0,5.56,0,8.71l-5.42.46C223.69,309.43,224.07,303.43,224.56,296.41Z",
    style: {
      fill: "#173c57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.68,287.69c-.46-1.09-.82-1.95-1.27-3l5-3.17c-2.21-6.78-4.33-13.33-6.66-20.48l5.5-.45c1.24,4.15,2.4,8.05,3.56,12l.8.14L115.3,261h4.2c.24.64.51,1,.44,1.24-1.89,6.19-3.64,12.44-5.81,18.53C112.71,284.7,109.93,287.47,104.68,287.69Z",
    style: {
      fill: "#173c57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.44,295.73c5-.16,9.35,4.3,9.64,10s-4,10.79-9.23,10.95c-5,.15-9.34-4.31-9.65-10S92.2,295.9,97.44,295.73Zm.88,4.43c-3.77.62-4.15,3.13-4.09,5.94.06,2.66-.1,5.45,3.54,5.94C102.13,309.34,102.44,304.24,98.32,300.16Z",
    style: {
      fill: "#173c57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.66,295.72c5.06,0,9.29,4.6,9.44,10.25s-4.28,10.74-9.47,10.74-9.29-4.61-9.44-10.26S165.47,295.72,170.66,295.72Zm-.09,16.35c4.65-2.54,4.94-8.23.6-11.82-2.83.24-3.93,2-3.89,4.66C167.33,307.76,166.46,311.09,170.57,312.07Z",
    style: {
      fill: "#173c57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.5,271.53c-1.79.13-3.55.28-5.32.38s-3.54.16-5.31.24l-.59,1.06,3.12,3.26,5.52-1.32,1.89,2.16c-.39.6-.56,1.17-.93,1.38-5,2.87-10.18,2.39-13.21-1.16s-3-11.07.18-14.89a8.2,8.2,0,0,1,12.34-.32A10,10,0,0,1,148.5,271.53Zm-11.3-4.44.65,1.2,6-.57-3.1-4.5Z",
    style: {
      fill: "#173c57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.64,307.52l-11.95.75-.45,1.18,3.07,3,5.56-1.26,1.94,2.35c-5.19,4.19-11,4-14.31-.23-3.59-4.57-2.52-13.07,2-16.17,3.77-2.56,9.15-1.69,11.38,2.23C220.16,301.53,220.57,304.18,221.64,307.52ZM209.2,303l.57,1h5.75L213,299Z",
    style: {
      fill: "#173c57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.36,275.15c3.07-.33,5.8,2.81,8.71-1-1.6-.85-2.92-1.65-4.31-2.29-4.39-2-6.2-4.41-5.34-7.28,1-3.27,5.51-5.57,9.48-4.62a35.75,35.75,0,0,1,4.83,2l-1.44,2.93c-2.44.69-4.78-2.49-7,1.24,1.6.79,3.07,1.6,4.61,2.27,3.52,1.52,4.65,3.08,4.45,6.31s-1.69,4.62-5.35,5.66-6.85,0-10.25-2.58C72.34,276.77,72.93,275.82,73.36,275.15Z",
    style: {
      fill: "#173c57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.78,279.29c-5,1.9-8.06,1-8.28-2.68-.45-7.71-.14-15.46-.14-23.59l5-.37C129.76,261.57,125.69,270.89,130.78,279.29Z",
    style: {
      fill: "#173c57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.72,278.26c-7,4.13-11.46,1.86-11.73-4.64-.1-2.47,0-4.95,0-7.19l-3-3.6c1.38-2.2,2.63-4.2,4.17-6.64l3-.47L97,260l3,1c1.29,3.32-1.75,3.46-3.41,4.73v8.71Z",
    style: {
      fill: "#173c57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.21,311.29l1.38,2.57c-4.59,3.6-9.09,3.56-12.55.05-3.27-3.32-3.53-10.94-.49-14.77s7.93-4.23,13-.82c-.46.9-.94,1.84-1.43,2.82l-5-.72c-3.56,3.38-3.84,5.87-1.17,10.87Z",
    style: {
      fill: "#173c57"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStzledcomponents);
export default __webpack_public_path__ + "static/media/stzledcomponents.c0deae890b85d78fc48927a1788ccaeb.svg";
export { ForwardRef as ReactComponent };